import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  name: Yup
    .string()
    .required('Nome é obrigatório'),
  expirationDays: Yup
    .string()
    .nullable()
    .when('allowedDomains', {
      is: allowedDomains => !allowedDomains || allowedDomains.length == 0,
      then: Yup
        .string()
        .nullable()
        .test(
          'expiration-required',
          'Expiração é obrigatória',
          value => value != '' && value != undefined
        )
    }),
  establishmentIds: Yup
    .array()
    .min(1, 'Escolha pelo menos um estabelecimento')
    .required()
});